import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Book, ExternalLink, Star, CheckCircle, X, BookOpen, Shield, Globe, TrendingUp, Heart, Award } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function BookPicsu() {
  const { language, t } = useLanguage();
  const [showLightbox, setShowLightbox] = useState(false);

  useEffect(() => {
    // Track page visit
    fetch(`${API_URL}/api/track/visit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page: 'book-picsu', language })
    }).catch(() => {});
  }, [language]);

  const content = {
    fr: {
      badge: "Manifeste de la Rupture",
      title: "PICSU : Le Nouveau Chapitre de la Santé Mondiale",
      subtitle: "L'ouvrage de référence qui réinvente le financement de la santé en Afrique",
      author: "Par Emile Scott PAGLAN NTAMACK",
      description: "Cet ouvrage présente l'approche révolutionnaire de PICSU pour la santé africaine. Une analyse complète des problématiques et des solutions innovantes pour une souveraineté sanitaire.",
      impactTitle: "Impact Direct",
      impactText: "PICSU n'est pas une simple théorie. C'est un modèle opérationnel déjà testé et prêt au déploiement. Ce livre documente l'ensemble du système permettant de garantir la transparence fiduciaire totale aux investisseurs tout en assurant l'accès aux soins pour les populations africaines.",
      themesTitle: "Thèmes Abordés",
      themes: [
        { icon: Heart, title: "Financement de la Santé", desc: "Modèles innovants de financement durable" },
        { icon: Shield, title: "Technologie Split Payment", desc: "Système automatisé de liquidation des soins" },
        { icon: Globe, title: "Infrastructure Autonome", desc: "CHRu 100% autonomes en énergie et eau" },
        { icon: Award, title: "Souveraineté Africaine", desc: "Indépendance sanitaire du continent" },
        { icon: CheckCircle, title: "Normes Internationales", desc: "Conformité aux standards mondiaux" },
        { icon: TrendingUp, title: "Modèle d'Investissement", desc: "ROI garanti et impact social" }
      ],
      orderButton: "Commander sur Amazon",
      protection: "Modèle protégé INPI N° DSO2026004704"
    },
    en: {
      badge: "Manifesto of Disruption",
      title: "PICSU: The New Chapter in Global Health",
      subtitle: "The reference book reinventing healthcare financing in Africa",
      author: "By Emile Scott PAGLAN NTAMACK",
      description: "This book presents PICSU's revolutionary approach to African healthcare. A comprehensive analysis of issues and innovative solutions for health sovereignty.",
      impactTitle: "Direct Impact",
      impactText: "PICSU is not just a theory. It's an operational model already tested and ready for deployment. This book documents the entire system enabling total fiduciary transparency for investors while ensuring healthcare access for African populations.",
      themesTitle: "Topics Covered",
      themes: [
        { icon: Heart, title: "Healthcare Financing", desc: "Innovative sustainable financing models" },
        { icon: Shield, title: "Split Payment Technology", desc: "Automated care settlement system" },
        { icon: Globe, title: "Autonomous Infrastructure", desc: "100% energy and water autonomous CHRu" },
        { icon: Award, title: "African Sovereignty", desc: "Healthcare independence for the continent" },
        { icon: CheckCircle, title: "International Standards", desc: "Global standards compliance" },
        { icon: TrendingUp, title: "Investment Model", desc: "Guaranteed ROI and social impact" }
      ],
      orderButton: "Order on Amazon",
      protection: "INPI Protected Model N° DSO2026004704"
    },
    pt: {
      badge: "Manifesto da Ruptura",
      title: "PICSU: O Novo Capítulo da Saúde Mundial",
      subtitle: "A obra de referência que reinventa o financiamento da saúde em África",
      author: "Por Emile Scott PAGLAN NTAMACK",
      description: "Esta obra apresenta a abordagem revolucionária do PICSU para a saúde africana. Uma análise completa das problemáticas e soluções inovadoras para uma soberania sanitária.",
      impactTitle: "Impacto Direto",
      impactText: "PICSU não é uma simples teoria. É um modelo operacional já testado e pronto para implantação. Este livro documenta todo o sistema que permite garantir total transparência fiduciária aos investidores, assegurando o acesso aos cuidados para as populações africanas.",
      themesTitle: "Temas Abordados",
      themes: [
        { icon: Heart, title: "Financiamento da Saúde", desc: "Modelos inovadores de financiamento sustentável" },
        { icon: Shield, title: "Tecnologia Split Payment", desc: "Sistema automatizado de liquidação de cuidados" },
        { icon: Globe, title: "Infraestrutura Autónoma", desc: "CHRu 100% autónomos em energia e água" },
        { icon: Award, title: "Soberania Africana", desc: "Independência sanitária do continente" },
        { icon: CheckCircle, title: "Normas Internacionais", desc: "Conformidade com padrões mundiais" },
        { icon: TrendingUp, title: "Modelo de Investimento", desc: "ROI garantido e impacto social" }
      ],
      orderButton: "Encomendar na Amazon",
      protection: "Modelo protegido INPI N° DSO2026004704"
    },
    it: {
      badge: "Manifesto della Rottura",
      title: "PICSU: Il Nuovo Capitolo della Sanità Mondiale",
      subtitle: "L'opera di riferimento che reinventa il finanziamento della sanità in Africa",
      author: "Di Emile Scott PAGLAN NTAMACK",
      description: "Quest'opera presenta l'approccio rivoluzionario di PICSU per la sanità africana. Un'analisi completa delle problematiche e delle soluzioni innovative per una sovranità sanitaria.",
      impactTitle: "Impatto Diretto",
      impactText: "PICSU non è una semplice teoria. È un modello operativo già testato e pronto per il deployment. Questo libro documenta l'intero sistema che permette di garantire la totale trasparenza fiduciaria agli investitori assicurando l'accesso alle cure per le popolazioni africane.",
      themesTitle: "Temi Trattati",
      themes: [
        { icon: Heart, title: "Finanziamento della Sanità", desc: "Modelli innovativi di finanziamento sostenibile" },
        { icon: Shield, title: "Tecnologia Split Payment", desc: "Sistema automatizzato di liquidazione delle cure" },
        { icon: Globe, title: "Infrastruttura Autonoma", desc: "CHRu 100% autonomi in energia e acqua" },
        { icon: Award, title: "Sovranità Africana", desc: "Indipendenza sanitaria del continente" },
        { icon: CheckCircle, title: "Standard Internazionali", desc: "Conformità agli standard mondiali" },
        { icon: TrendingUp, title: "Modello di Investimento", desc: "ROI garantito e impatto sociale" }
      ],
      orderButton: "Ordinare su Amazon",
      protection: "Modello protetto INPI N° DSO2026004704"
    },
    ru: {
      badge: "Манифест Прорыва",
      title: "PICSU: Новая Глава Мирового Здравоохранения",
      subtitle: "Референтное издание, переосмысливающее финансирование здравоохранения в Африке",
      author: "Автор: Эмиль Скотт ПАГЛАН НТАМАК",
      description: "Эта работа представляет революционный подход PICSU к африканскому здравоохранению. Полный анализ проблем и инновационных решений для суверенитета в здравоохранении.",
      impactTitle: "Прямое Воздействие",
      impactText: "PICSU — это не просто теория. Это операционная модель, уже протестированная и готовая к развёртыванию. Эта книга документирует всю систему, обеспечивающую полную фидуциарную прозрачность для инвесторов при гарантии доступа к медицинской помощи для африканского населения.",
      themesTitle: "Рассмотренные Темы",
      themes: [
        { icon: Heart, title: "Финансирование здравоохранения", desc: "Инновационные модели устойчивого финансирования" },
        { icon: Shield, title: "Технология Split Payment", desc: "Автоматизированная система расчётов за медпомощь" },
        { icon: Globe, title: "Автономная инфраструктура", desc: "100% автономные CHRu по энергии и воде" },
        { icon: Award, title: "Африканский суверенитет", desc: "Независимость здравоохранения континента" },
        { icon: CheckCircle, title: "Международные стандарты", desc: "Соответствие мировым стандартам" },
        { icon: TrendingUp, title: "Инвестиционная модель", desc: "Гарантированный ROI и социальное воздействие" }
      ],
      orderButton: "Заказать на Amazon",
      protection: "Модель защищена INPI № DSO2026004704"
    },
    zh: {
      badge: "突破宣言",
      title: "PICSU：全球卫生的新篇章",
      subtitle: "重新定义非洲卫生融资的参考著作",
      author: "作者：Emile Scott PAGLAN NTAMACK",
      description: "本著作介绍了PICSU对非洲卫生的革命性方法。全面分析问题和主权卫生的创新解决方案。",
      impactTitle: "直接影响",
      impactText: "PICSU不仅是理论。它是一个已经测试并准备部署的运营模型。这本书记录了整个系统，在保证非洲人民获得医疗服务的同时，为投资者提供完全的信托透明度。",
      themesTitle: "涵盖主题",
      themes: [
        { icon: Heart, title: "卫生融资", desc: "创新的可持续融资模式" },
        { icon: Shield, title: "分账支付技术", desc: "自动化医疗结算系统" },
        { icon: Globe, title: "自主基础设施", desc: "100%能源和水自主的CHRu" },
        { icon: Award, title: "非洲主权", desc: "大陆卫生独立" },
        { icon: CheckCircle, title: "国际标准", desc: "符合全球标准" },
        { icon: TrendingUp, title: "投资模式", desc: "保证ROI和社会影响" }
      ],
      orderButton: "在亚马逊订购",
      protection: "INPI保护模型 编号 DSO2026004704"
    }
  };

  const c = content[language] || content.fr;

  return (
    <div className="min-h-screen bg-white" data-testid="book-picsu-page">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-emerald-900 text-white py-20 overflow-hidden">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNiIgc3Ryb2tlPSJyZ2JhKDI1NSwyNTUsMjU1LDAuMDUpIiBzdHJva2Utd2lkdGg9IjIiLz48L2c+PC9zdmc+')] opacity-30"></div>
        
        <div className="max-w-6xl mx-auto px-6 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block px-4 py-2 bg-emerald-600/20 border border-emerald-400/30 rounded-full backdrop-blur-sm mb-6">
                <p className="text-sm font-medium text-emerald-300 uppercase tracking-wider flex items-center gap-2">
                  <Book className="w-4 h-4" />
                  {c.badge}
                </p>
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" style={{fontFamily: 'Playfair Display, serif'}}>
                {c.title}
              </h1>
              
              <p className="text-lg md:text-xl text-slate-300 mb-4">{c.subtitle}</p>
              <p className="text-base text-emerald-400 font-medium mb-8">{c.author}</p>
              
              <a 
                href="https://www.amazon.fr/dp/B0DPT3DDPF"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="amazon-order-btn"
                className="inline-flex items-center gap-3 px-8 py-4 bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold rounded-full transition-all hover:scale-105 shadow-lg"
              >
                <BookOpen className="w-6 h-6" />
                {c.orderButton}
                <ExternalLink className="w-5 h-5" />
              </a>
              
              <p className="mt-6 text-sm text-slate-400 flex items-center gap-2">
                <Shield className="w-4 h-4 text-emerald-400" />
                {c.protection}
              </p>
            </div>
            
            <div className="relative">
              <div 
                className="cursor-pointer transform hover:scale-105 transition-all"
                onClick={() => setShowLightbox(true)}
                data-testid="book-cover-click"
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/tysf0jqk_COUVERTURE%20PICSU.png"
                  alt="PICSU Book Cover"
                  className="w-full max-w-md mx-auto rounded-2xl shadow-2xl border-4 border-white/10"
                />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
                  <div className="bg-black/50 backdrop-blur-sm px-6 py-3 rounded-full text-white font-medium">
                    {language === 'fr' ? 'Cliquer pour agrandir' : 'Click to enlarge'}
                  </div>
                </div>
              </div>
              
              {/* Rating Badge */}
              <div className="absolute -bottom-4 -right-4 bg-white rounded-2xl p-4 shadow-xl">
                <div className="flex items-center gap-1 mb-1">
                  {[1,2,3,4,5].map(i => (
                    <Star key={i} className="w-5 h-5 text-amber-500 fill-amber-500" />
                  ))}
                </div>
                <p className="text-xs text-slate-600 font-medium">Amazon Reviews</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Description Section */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-4xl mx-auto px-6">
          <p className="text-lg text-slate-700 leading-relaxed mb-8">{c.description}</p>
          
          <div className="bg-white border border-slate-200 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3" style={{fontFamily: 'Playfair Display, serif'}}>
              <TrendingUp className="w-7 h-7 text-emerald-600" />
              {c.impactTitle}
            </h2>
            <p className="text-base text-slate-600 leading-relaxed">{c.impactText}</p>
          </div>
        </div>
      </section>

      {/* Themes Grid */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 text-center mb-12" style={{fontFamily: 'Playfair Display, serif'}}>
            {c.themesTitle}
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {c.themes.map((theme, i) => (
              <div 
                key={i}
                className="bg-white border border-slate-200 rounded-2xl p-6 hover:shadow-lg hover:border-emerald-300 transition-all"
                data-testid={`theme-card-${i}`}
              >
                <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center mb-4">
                  <theme.icon className="w-7 h-7 text-emerald-600" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2">{theme.title}</h3>
                <p className="text-sm text-slate-600">{theme.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-emerald-600">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-6" style={{fontFamily: 'Playfair Display, serif'}}>
            {c.orderButton}
          </h2>
          <a 
            href="https://www.amazon.fr/dp/B0DPT3DDPF"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-5 bg-white hover:bg-slate-100 text-emerald-700 font-bold text-lg rounded-full transition-all hover:scale-105 shadow-lg"
          >
            <BookOpen className="w-7 h-7" />
            Amazon
            <ExternalLink className="w-6 h-6" />
          </a>
        </div>
      </section>

      {/* Lightbox */}
      {showLightbox && (
        <div 
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={() => setShowLightbox(false)}
          data-testid="book-lightbox"
        >
          <button 
            className="absolute top-6 right-6 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
            onClick={() => setShowLightbox(false)}
          >
            <X className="w-6 h-6 text-white" />
          </button>
          <img 
            src="https://customer-assets.emergentagent.com/job_sustainable-africa-4/artifacts/tysf0jqk_COUVERTURE%20PICSU.png"
            alt="PICSU Book Cover"
            className="max-w-full max-h-[90vh] rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
